<template>
  <div id="InfoProgram">
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false" :md-close-on-esc="false">

      <div style="width:100%; padding:5px">
      <!-- <md-button class="md-primary" style="position: relative; width: 80px; float: right;" @click="closeDialog(0)">Zamknij</md-button> -->
      <button class="btn btn-default" @click="closeDialog(0)"
      style="float: right; margin: 5px 34px; color:#007bff;background:#fff;border:1px solid #007bff">{{$t('message.zamknij')}}</button>
      </div>
      <md-dialog-title>{{$t('message.dane_adresowe')}}</md-dialog-title>
      <div id="content">

        <form>
          <div class="wiersz">

            <div class="kolumny">
              <h5>{{$t('message.firma_zamaw')}}:</h5>
              <div class="form-grupa">
                <label for="staticNazwa" class="col-form-label">{{$t('message.nazwa_firmy')}}:</label>
                <input type="text" class="form-control form-control-sm" id="staticNazwa"
                v-model.lazy="zamawiajacy.nazwa">
              </div>
              <div class="form-grupa">
                <label for="inputAdres" class="col-form-label">{{$t('message.adres')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputAdres"
                v-model.lazy="zamawiajacy.adres">
              </div>
              <div class="form-grupa">
                <label for="inputMiasto" class="col-form-label">{{$t('message.miasto')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputKod" style="width: 20%; float: left; margin-right: 4%;"
                v-model.lazy="zamawiajacy.kod_miasta">
                <input type="text" class="form-control form-control-sm" id="inputMiasto" style="width: 76%; float: left;"
                v-model.lazy="zamawiajacy.miasto">
              </div>
              <div class="form-grupa">
                <label for="inputTelefon" class="col-form-label">{{$t('message.tel')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputTelefon"
                v-model.lazy="zamawiajacy.tel">
              </div>
              <div class="form-grupa">
                <label for="inputMail" class="col-form-label">{{$t('message.email')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputMail"
                v-model.lazy="zamawiajacy.email">
              </div>
              <div class="form-grupa">
                <label for="inputNIP" class="col-form-label">NIP:</label>
                <input type="text" class="form-control form-control-sm" id="inputNIP"
                v-model.lazy="zamawiajacy.nip">
              </div>
            </div>

            <div class="kolumny">
              <h5>{{$t('message.inwestycja')}}:</h5>
              <div class="form-grupa">
                <label for="staticNazwaInwest" class="col-form-label">{{$t('message.nazwa_inwest')}}:</label>
                <input type="text" class="form-control form-control-sm" id="staticNazwaInwest"
                v-model.lazy="inwestycja.nazwa">
              </div>

              <div class="form-grupa">
                <label for="flexCheckDefault2" class="col-form-label">Nazwa konfiguracji / pliku <span style="font-size: 12px;color: gray;">(nie wymagane)</span>:
                  <!-- <input class="" type="checkbox" v-model="myFileName" id="flexCheckDefault2" style="margin-left:10px"> -->
                </label>
                <input v-if="myFileName" type="text" class="form-control form-control-sm" id="staticNazwa" v-model.lazy="fileName">
              </div>
              <!-- <div class="form-grupa">
                <label for="inputBiuro" class="col-form-label">{{$t('message.biuro')}}:</label>
                <br>
                <input type="text" class="form-control form-control-sm" id="inputBiuro"
                v-model.lazy="inwestycja.biuro_projektant">
              </div> -->

              <div class="form-grupa">
                <label for="inputAdres" class="col-form-label">{{$t('message.dane_adresowe')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputAdres"
                v-model.lazy="inwestycja.adres">
              </div>
              <div class="form-grupa">
                <label for="inputMiasto" class="col-form-label">{{$t('message.miasto')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputKod" style="width: 20%; float: left; margin-right: 4%;"
                v-model.lazy="inwestycja.kod_miasta">
                <input type="text" class="form-control form-control-sm" id="inputMiasto" style="width: 76%; float: left;"
                v-model.lazy="inwestycja.miasto">
              </div>
              <div class="form-grupa">
                <label for="inputTelefonKontakt" class="col-form-label">{{$t('message.tel_kontakt')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputTelefonKontakt"
                v-model.lazy="inwestycja.tel">
              </div>
              <div class="form-grupa">
                <label for="inputMailKontakt" class="col-form-label">{{$t('message.email_kontakt')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputMailKontakt"
                v-model.lazy="inwestycja.email">
              </div>
            </div>

          </div>

          <div class="form-check">
            <input class="form-check-input" type="checkbox" v-model="innyAdres" id="flexCheckDefault">
            <label class="form-check-label" for="flexCheckDefault">
              {{$t('message.inny_adres')}}
            </label>
          </div>

          <div class="wiersz" style="height:170px" v-if="innyAdres">

            <div class="kolumny">
              <div class="form-grupa">
                <label for="staticNazwa" class="col-form-label">{{$t('message.nazwa_firmy')}}:</label>
                <input type="text" class="form-control form-control-sm" id="staticNazwa"
                v-model.lazy="wysylka.nazwa">
              </div>
              <div class="form-grupa">
                <label for="inputAdres" class="col-form-label">{{$t('message.imie')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputAdres"
                v-model.lazy="wysylka.imie_nazwisko">
              </div>
            </div>
            <div class="kolumny">
              <div class="form-grupa">
                <label for="inputAdres" class="col-form-label">{{$t('message.adres_wysylki')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputAdres"
                v-model.lazy="wysylka.adres">
              </div>
              <div class="form-grupa">
                <label for="inputMiasto" class="col-form-label">{{$t('message.miasto')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputKod" style="width: 20%; float: left; margin-right: 4%;"
                v-model.lazy="wysylka.kod_miasta">
                <input type="text" class="form-control form-control-sm" id="inputMiasto" style="width: 76%; float: left;"
                v-model.lazy="wysylka.miasto">
              </div>
              <div class="form-grupa">
                <label for="inputTelefon" class="col-form-label">{{$t('message.tel')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputTelefon"
                v-model.lazy="wysylka.tel">
              </div>
            </div>

          </div>

          <hr style="width: 450px;">
<!--
          <div class="" style="margin-left: 18px;">
            <input class="" type="checkbox" v-model="myFileName" id="flexCheckDefault2">
            <label class="" for="flexCheckDefault2">
              nazwa konfiguracji / pliku
            </label>
          </div>

          <div class="wiersz" style="height:30px" v-if="myFileName">
              <div class="form-grupa" style="height: 25px;width: 350px;margin-bottom: 0px;">
                <input type="text" class="form-control form-control-sm" id="staticNazwa"
                v-model.lazy="fileName">
              </div>
          </div> -->

          <button class="btn btn-primary" @click.prevent="saveForm" style="float: right; margin: 10px 34px;">
          {{$t('message.zapisz')}}</button>

        </form>

      </div>
    </md-dialog>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { app } from '../../mixins/app'

export default {
  name: 'DaneAdresowe',
  props: ['showDialog'],
  mixins: [app],
  data () {
    return {
      myFileName: true,
      fileName: '',
      innyAdres: false,
      zamawiajacy: {
        nazwa: '',
        adres: '',
        kod_miasta: '',
        miasto: '',
        tel: '',
        email: '',
        nip: ''
      },
      inwestycja: {
        nazwa: '',
        biuro_projektant: '',
        adres: '',
        kod_miasta: '',
        miasto: '',
        tel: '',
        email: ''
      },
      wysylka: {
        nazwa: '',
        imie_nazwisko: '',
        adres: '',
        kod_miasta: '',
        miasto: '',
        tel: ''
      }
    }
  },
  computed: {
    // ...mapGetters('app', ['config']),
    // ...mapGetters('app', ['inputs']),
    ...mapGetters('app', ['outputs'])
  },
  watch: {
    outputs: {
      deep: true, // <!-- This is important;
      handler (newValue) {
        // console.log(newValue)
        this.zamawiajacy = newValue.zamawiajacy
        this.inwestycja = newValue.inwestycja
        this.wysylka = newValue.wysylka
        // Object.keys(this.inputData).forEach(element => {
        //   console.log(element)
        //   // this.inputData[element]['value'] = newValue[element].value
        // })
      }
    }
  },
  methods: {
    closeDialog () {
      this.$emit('clickedClose', false)
    },
    saveForm () {
      // console.log(this.zamawiajacy)
      // console.log(this.inwestycja)
      // console.log(this.innyAdres)
      // console.log(this.wysylka)
      if (this.myFileName) {
        this.changeValueOutputs('nazwaPliku', 'value', this.fileName)
      }
      this.changeValueOutputs('zamawiajacy', 'array', this.zamawiajacy)
      this.changeValueOutputs('inwestycja', 'array', this.inwestycja)
      if (this.innyAdres) {
        this.changeValueOutputs('wysylka', 'array', this.wysylka)
      }
      this.$emit('clickedClose', false)
    }
  }
}
</script>

<style scoped>
.row {
  margin: 15px;
}
.wiersz {
  width: 100%;
  height: 400px;
  padding: 0px 15px;
  display: inline-flex;
}
.kolumny{
  width:46%;
}
.kolumny:first-child{
  margin-left:2%;
  margin-right:4%
}
.md-dialog-title {
    margin-bottom: 10px;
    padding: 0px 36px 0;
}
div.md-dialog {
  background: rgba(0,0,0,0.6);
}
div.form-grupa {
  width:100%;
  margin-bottom: 8px;
  height: 52px;
}
div.form-grupa label {
  width:100%;padding: 0px 4px;
}
.form-check {
width: 100%;
text-align: right;
margin-right: 50px;
position: relative;
right: 40px;
bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialogs/DaneAdresowe.vue